import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: '#fff',
    className: null,
};

const GalaxyIcon = ({ color, className }) => (
    <svg
        // width="390"
        // height="459"
        viewBox="0 0 390 459"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <g>
            <path
                d="M286.7 247.58C289.326 221.203 250.412 192.364 199.783 183.167C149.153 173.969 105.981 187.895 103.355 214.272C100.728 240.648 139.643 269.487 190.272 278.685C240.901 287.882 284.073 273.956 286.7 247.58Z"
                stroke="#FFfc00"
                strokeMiterlimit="10"
            />
            <path
                d="M355.002 258.632C359.655 211.895 291.299 160.904 202.323 144.74C113.348 128.576 37.4463 153.36 32.7927 200.097C28.1391 246.834 96.4955 297.825 185.471 313.989C274.447 330.153 350.348 305.369 355.002 258.632Z"
                stroke="#f56"
                strokeMiterlimit="10"
            />
            <path
                d="M415.378 269.601C421.797 205.134 327.84 134.86 205.52 112.638C83.1991 90.4163 -21.1649 124.662 -27.5838 189.128C-34.0027 253.595 59.9541 323.869 182.275 346.091C304.595 368.313 408.959 334.067 415.378 269.601Z"
                stroke="#008097"
                strokeMiterlimit="10"
            />
            <path
                d="M485.471 282.334C493.84 198.283 370.082 106.431 209.051 77.1764C48.0188 47.922 -89.3075 92.3436 -97.6765 176.395C-106.045 260.446 17.7121 352.298 178.744 381.553C339.775 410.807 477.102 366.385 485.471 282.334Z"
                stroke="#0521ce"
                strokeMiterlimit="10"
            />
            <path
                d="M549.17 293.907C559.37 191.467 408.578 79.526 212.366 43.8804C16.1539 8.23485 -151.176 62.3825 -161.376 164.823C-171.576 267.263 -20.7834 379.203 175.428 414.849C371.64 450.494 538.97 396.347 549.17 293.907Z"
                stroke="#d787ff"
                strokeMiterlimit="10"
            />
            <path
                d="M607.341 304.474C619.195 185.421 443.7 55.2818 215.361 13.7998C-12.9779 -27.6822 -207.693 35.2016 -219.547 154.255C-231.401 273.308 -55.9055 403.447 172.433 444.929C400.772 486.411 595.487 423.527 607.341 304.474Z"
                stroke="#ff0032"
                strokeMiterlimit="10"
            />
        </g>
    </svg>
);

GalaxyIcon.propTypes = propTypes;
GalaxyIcon.defaultProps = defaultProps;

export default GalaxyIcon;
